<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    :src="image"
    app
    color="grey darken-2"
    dark
    floating
    mobile-breakpoint="991"
    persistent
    width="260"
  >
    <template #img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-avatar color="white">
        <v-img
          src="https://cdn.vuetifyjs.com/images/logos/v.png"
          height="34"
          contain
        />
      </v-list-item-avatar>

      <v-list-item-title class="title">
        Console AD
      </v-list-item-title>
    </v-list-item>

    <v-divider class="mx-3 mb-3" />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <template
        v-for="(link, i) in links"
      >
        <template v-if="!link.children">
          <v-list-item :key="i" :to="link.to" active-class="primary white--text">
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-title v-text="link.text" />
          </v-list-item>
        </template>
        <template v-else>
          <v-list-group
            :key="i"
            no-action
            sub-group
          >
            <template #activator>
              <v-list-item-content>
                <v-list-item-title>{{ link.text }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(child, k) in link.children"
              :key="k"
              :to="child.to"
              active-class="primary white--text"
            >
              <v-list-item-title v-text="child.text" />
            </v-list-item>
          </v-list-group>
        </template>
      </template>

      <template #append>
        <v-list nav>
          <v-list-item to="#">
            <v-list-item-action>
              <v-icon>mdi-package-up</v-icon>
            </v-list-item-action>

            <v-list-item-title class="font-weight-light">
              Something else
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from 'vuex'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    links: [
      {
        to: '/',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard'
      },
      {
        to: '/users/list',
        icon: 'mdi-account-group',
        text: 'Пользователи'
      },
      {
        to: '/articles',
        icon: 'mdi-view-dashboard',
        text: 'Статьи'
      },
      {
        to: '/news',
        icon: 'mdi-view-dashboard',
        text: 'Новости'
      },
      {
        icon: 'mdi-file-tree-outline',
        text: 'Каталог',
        children: [
          {
            to: '/catalog/category-list',
            icon: 'mdi-file-tree-outline',
            text: 'Категории'
          },
          {
            to: '/catalog-list',
            icon: 'mdi-file-tree-outline',
            text: 'Главная'
          }
        ]
      },
      {
        to: '/catalog/params',
        icon: 'mdi-file-tree-outline',
        text: 'Параметры'
      },
      {
        to: '/catalog/products',
        icon: 'mdi-gift-outline',
        text: 'Товары'
      },
      {
        icon: 'mdi-gift-outline',
        text: 'Бренды',
        children: [
          {
            to: '/brands',
            icon: 'mdi-gift-outline',
            text: 'Бренды'
          },
          {
            to: '/brand-page-settings',
            icon: 'mdi-gift-outline',
            text: 'Настройки брендов'
          }
        ]
      },
      {
        icon: 'mdi-gift-outline',
        text: 'Заказы',
        children: [
          {
            to: '/orders/list',
            icon: 'mdi-gift-outline',
            text: 'Заказы'
          },
          {
            to: '/discounts',
            icon: 'mdi-gift-outline',
            text: 'Скидки'
          },
          {
            to: '/deliveries',
            icon: 'mdi-gift-outline',
            text: 'Способы доставки'
          },
          {
            to: '/payments',
            icon: 'mdi-gift-outline',
            text: 'Способы оплаты'
          },
          {
            to: '/order-gifts',
            icon: 'mdi-gift-outline',
            text: 'Подарки к заказу'
          },
          {
            to: '/orders/stat',
            icon: 'mdi-gift-outline',
            text: 'Статистика заказов'
          }
        ]
      },
      {
        to: '/certificates',
        icon: 'mdi-gift-outline',
        text: 'Сертификаты'
      },
      {
        to: '/press',
        icon: 'mdi-gift-outline',
        text: 'Пресса о нас'
      },
      {
        to: '/clients',
        icon: 'mdi-gift-outline',
        text: 'Наши клиенты'
      },
      {
        to: '/subscriptions',
        icon: 'mdi-email-open-outline',
        text: 'Подписчики'
      },
      {
        icon: 'mdi-gift-outline',
        text: 'Главная',
        children: [
          {
            to: '/main-page-main-carousel',
            icon: 'mdi-gift-outline',
            text: 'Карусель'
          },
          {
            to: '/main-page-banners',
            icon: 'mdi-gift-outline',
            text: 'Баннеры'
          },
          {
            to: '/main-page-join-us',
            icon: 'mdi-gift-outline',
            text: 'Присоединяйтесь к нам'
          }
        ]
      },
      {
        icon: 'mdi-gift-outline',
        text: 'Настройки баннеров',
        children: [
          {
            to: '/banner-category',
            icon: 'mdi-gift-outline',
            text: 'Категории баннеров'
          },
          {
            to: '/banner-medias',
            icon: 'mdi-gift-outline',
            text: 'Медиа запросы'
          }
        ]
      },
      {
        to: '/robots',
        icon: 'mdi-gift-outline',
        text: 'Robots'
      }
    ]
  }),

  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    }
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer'])
  }
}
</script>
<style>
  #app-drawer .v-list-group__header{
    padding-left: 10px
  }
  #app-drawer .v-list-group--no-action.v-list-group--sub-group > .v-list-group__items > .v-list-item {
    padding-left: 50px !important
  }
</style>
